/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterBSmall = createReactComponent("letter-b-small", "IconLetterBSmall", [
  [
    "path",
    { d: "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z", key: "svg-0" }
  ]
]);

export { IconLetterBSmall as default };
//# sourceMappingURL=IconLetterBSmall.js.map
